import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M11.12 5.2h5.6a.8.8 0 0 1 .8.8v7.2a.8.8 0 0 1-.8.8h-5.6a.8.8 0 0 1-.8-.8V6a.8.8 0 0 1 .8-.8m-2 .8a2 2 0 0 1 2-2h5.6a2 2 0 0 1 2 2v7.2a2 2 0 0 1-2 2h-1.84V18a2 2 0 0 1-2 2h-5.6a2 2 0 0 1-2-2v-7.2a2 2 0 0 1 2-2h1.84zm0 4H7.28a.8.8 0 0 0-.8.8V18a.8.8 0 0 0 .8.8h5.6a.8.8 0 0 0 .8-.8v-2.8h-2.56a2 2 0 0 1-2-2z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon-copy"}) } }